<template>
  <div class="entity-preview">
    <div v-if="!data || data.length === 0" class="no-data">
      <p>No export data extracted</p>
    </div>
    <div v-else class="data-table">
      <table>
        <thead>
          <tr>
            <th>Consignment ID</th>
            <th>Lot No</th>
            <th>Container IDs</th>
            <th>Vessel Name</th>
            <th>ETD Planned</th>
            <th>Port ID</th>
            <th>Destination</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in data" :key="index" :class="{ expanded: item.expanded }">
            <td>{{ item.ConsignmentID }}</td>
            <td>{{ item.LotNo }}</td>
            <td>{{ item.ContainerIDs }}</td>
            <td>{{ item.VesselName }}</td>
            <td>{{ item.ETD_Planned }}</td>
            <td>{{ item.PortID }}</td>
            <td>{{ item.DestinationCountry }}</td>
            <td>
              <div class="action-buttons">
                <button class="btn-icon" @click="toggleExpand(index)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </button>
                <button class="btn-icon delete" @click="deleteItem(index)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                  </svg>
                </button>
              </div>
            </td>
          </tr>
          <tr v-for="(item, index) in data" :key="`details-${index}`" class="details-row" v-show="item.expanded">
            <td colspan="8">
              <div class="details-content">
                <div class="details-form">
                  <div class="form-group">
                    <label>Consignment ID</label>
                    <input type="text" v-model="item.ConsignmentID">
                  </div>
                  <div class="form-group">
                    <label>Lot No</label>
                    <input type="text" v-model="item.LotNo">
                  </div>
                  <div class="form-group">
                    <label>Container IDs</label>
                    <input type="text" v-model="item.ContainerIDs">
                  </div>
                  <div class="form-group">
                    <label>Vessel Name</label>
                    <input type="text" v-model="item.VesselName">
                  </div>
                  <div class="form-group">
                    <label>ETD Planned</label>
                    <input type="text" v-model="item.ETD_Planned">
                  </div>
                  <div class="form-group">
                    <label>Port ID</label>
                    <input type="text" v-model="item.PortID">
                  </div>
                  <div class="form-group">
                    <label>Destination Country</label>
                    <input type="text" v-model="item.DestinationCountry">
                  </div>
                </div>
                <div class="details-actions">
                  <button class="btn-secondary" @click="updateItem(index)">Update</button>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  methods: {
    toggleExpand(index) {
      const updatedData = [...this.data];
      updatedData[index].expanded = !updatedData[index].expanded;
      this.$emit('update', updatedData);
    },
    updateItem(index) {
      this.$emit('update', [...this.data]);
      this.toggleExpand(index);
    },
    deleteItem(index) {
      if (confirm('Are you sure you want to delete this item?')) {
        const updatedData = [...this.data];
        updatedData.splice(index, 1);
        this.$emit('update', updatedData);
      }
    }
  }
};
</script>

<style scoped>
.entity-preview {
  margin-bottom: 20px;
}

.data-table {
  overflow-x: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #e5e7eb;
}

th {
  background-color: #f9fafb;
  font-weight: 600;
  color: #374151;
}

tr:hover {
  background-color: #f9fafb;
}

.action-buttons {
  display: flex;
  gap: 4px;
}

.btn-icon {
  background: none;
  border: none;
  cursor: pointer;
  color: #6b7280;
  padding: 4px;
  border-radius: 4px;
}

.btn-icon:hover {
  background-color: #f3f4f6;
  color: #111827;
}

.btn-icon.delete:hover {
  background-color: #fee2e2;
  color: #b91c1c;
}

.expanded .btn-icon svg {
  transform: rotate(180deg);
}

.details-row {
  background-color: #f9fafb;
}

.details-content {
  padding: 16px;
}

.details-form {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 16px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 4px;
}

.form-group input {
  padding: 8px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
}

.details-actions {
  display: flex;
  justify-content: flex-end;
}

.btn-secondary {
  background-color: white;
  color: #374151;
  border: 1px solid #d1d5db;
  padding: 8px 16px;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
}

.btn-secondary:hover {
  background-color: #f9fafb;
  border-color: #9ca3af;
}

.no-data {
  padding: 40px;
  text-align: center;
  color: #6b7280;
  background-color: #f9fafb;
  border-radius: 8px;
  border: 1px dashed #d1d5db;
}
</style>
